import { getMonitoringSource } from '@op/components/TableCommonHook/utils';
import { sentimentNumber } from './value';
import { validTypeMap } from '@op/constants/common';

export function commentType(item: {
  comment_id: string;
  comment_parent_id: string;
}) {
  return item.comment_id !== '-1' && item.comment_parent_id === '-1'
    ? 'Posts'
    : 'Reply';
}

export function monitorSourceName(item: {
  keyword_or_account: any;
  monitor_source: any;
  keyword_account_name: any;
}) {
  const { keyword_or_account, monitor_source, keyword_account_name } = item;
  // 老版本使用这个，新版本会是数组
  if (typeof monitor_source === 'string') {
    let sourceName = 'by Account:';
    if (keyword_or_account === 'keyword') {
      sourceName = 'by Keyword:';
      sourceName += keyword_account_name;
    } else if (monitor_source.length > 0) {
      sourceName += `${keyword_account_name}(${monitor_source})`;
    } else {
      sourceName += keyword_account_name;
    }
    return sourceName;
  }

  if (Array.isArray(monitor_source)) {
    const { keyword, external, accountCategories } =
      getMonitoringSource(monitor_source);
    const parts: string[] = [];

    // Keyword
    if (keyword.length > 0) {
      parts.push(`by Keyword: ${keyword.map(item => item.name).join(', ')}`);
    }

    // Account Categories
    accountCategories.forEach(category => {
      if (category.list.length > 0) {
        parts.push(
          `${category.textInfo.text}: ${category.list
            .map(item => item.name)
            .join(', ')}`,
        );
      }
    });

    // External
    if (external.length > 0) {
      parts.push(
        `by External Data Sources: ${external
          .map(item => item.name)
          .join(', ')}`,
      );
    }

    return `${parts.join('; ')} `;
  }

  return '';
}

const sentimentRatingMap: any = {
  1: 'Negative',
  3: 'Neutral',
  5: 'Positive',
};

export function hideSentimentFunc(hideSentimentRating: boolean) {
  if (hideSentimentRating) {
    return (item: { [x: string]: any }, key: string | number) => {
      const value = item[key];
      return sentimentRatingMap[value] || 'Untagged';
    };
  }

  return sentimentNumber;
}

export function getExtJsonValue({
  valueKey,
  dealwithList,
}: {
  valueKey: string;
  dealwithList: Array<any>;
}) {
  return (item: any, key: string) => {
    try {
      const data = JSON.parse(item[key]);
      let value = data[valueKey];

      if (Array.isArray(dealwithList)) {
        dealwithList.forEach(func => {
          value = func({ value }, 'value');
        });
      }
      return value;
    } catch (error) {}
  };
}

export function renderHelperLiveBroadcastViews(
  item: {
    [x: string]: number | string;
  },
  key: string | number,
) {
  if (item?.channel_name !== 'chzzk') return '-';
  try {
    const obj = JSON.parse(item?.ext_json);
    const value = obj[key];
    return value || '-';
  } catch (error) {
    return '-';
  }
}

// 游戏商店相关辅助函数
export function reviewerPlaytime(
  item: {
    record_duration: any;
    review_duration: any;
    channel_name: any;
  },
  key: string | number,
) {
  const { record_duration, review_duration, channel_name } = item;

  if (channel_name !== 'steam') return '';

  const hasDuration = (num: number) => {
    if (!isNaN(num) && num > 0) {
      return true;
    }
    return false;
  };

  const hasRecordDuration = hasDuration(record_duration);
  const hasReviewDuration = hasDuration(review_duration);
  if (key === 'on_record_time' && hasRecordDuration) {
    return record_duration;
  }
  if (key === 'at_review_time' && hasReviewDuration) {
    return review_duration;
  }

  return '-';
}

export function gameStoreRating(
  item: {
    [x: string]: any;
    channel_name?: any;
    is_recommend?: any;
    monitor_source?: any;
  },
  key: string | number,
) {
  const { channel_name, is_recommend, monitor_source } = item;

  if (channel_name === 'steam') {
    if (is_recommend === 1) return 'Recommended';
    if (is_recommend === 0) return 'Not Recommended';
  }

  if (channel_name === 'metacritic') {
    let reviews = '';
    if (typeof monitor_source === 'string') {
      reviews = monitor_source?.toLowerCase?.()?.trim();
    } else if (Array.isArray(monitor_source)) {
      reviews = monitor_source[0].type?.toLowerCase?.()?.trim();
    }

    const review = reviews.includes('_') ? reviews.split('_')[0] : '';

    let score = item[key];
    if (score == -1) return 'Unscored';

    score = isNaN(item[key]) ? 0 : item[key];

    if ('user' == review) {
      return `User Score：${Number(score).toFixed(1)}`;
    }
    if ('critic' == review) {
      return `Metascore：${Number(score).toFixed(0)}`;
    }
  }

  const score = item[key];
  if (score == -1) return 'Unscored';

  if (!isNaN(score)) {
    return Number(score);
  }
  return score;
}

const commonGameStoreTextMap: any = {
  steam: 'Customer Reviews',
  opencritic: 'Critic Reviews',
};
const metacriticTextMap: any = {
  user_review: 'Customer Reviews',
  critic_review: 'Critic Reviews',
};

function getMonitorSource(item: any) {
  const { name, type, source } = item;
  if (source === 'keyword') {
    return name;
  }

  if (!['steam', 'opencritic'].includes(name)) {
    return metacriticTextMap[type];
  }

  return commonGameStoreTextMap[name];
}

// 处理 Monitor Source
export function renderMonitorSource(data: any, key: string) {
  const list = (data[key] || [])
    .map((item: any) => {
      return getMonitorSource(item);
    })
    .filter(Boolean);

  return list.join(', ');
}

function getGameStoreExtJson(
  data: any,
  key: string,
  func?: (value: any) => string,
) {
  if (data.channel_name !== 'steam') return '-';
  try {
    const obj = JSON.parse(data.ext_json);
    const value = obj[key];
    if (value && !func) return value;
    if (func) return func(value);
    return value ?? '-';
  } catch (error) {
    return '-';
  }
}

// 游戏商店 ext_json 获取辅助函数
export function gameStoreExtJsonHelper(
  key: string,
  func?: (value: any) => string,
): (item: any, _key: string) => string | number {
  return (item: any) => getGameStoreExtJson(item, key, func);
}

// 内容回退兼容处理
export function newsBakContent(bak: string) {
  return (item: { [key: string]: any }, key: string) =>
    item[key] || item?.[bak]?.[key];
}

// 内容回退兼容处理
export function renderIsValid(data: any, key: string) {
  const value = data?.[key];
  return validTypeMap?.[value] || value || '-';
}
